import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './Auth.css';
import AuthService from '../services/authService';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .required('Foydalanuvchi nomi kiritilishi shart'),
      password: Yup.string()
        .required('Parol kiritilishi shart')
        .min(3, 'Parol kamida 3 ta belgidan iborat bo\'lishi kerak'),
    }),
    onSubmit: async (values) => {
      try {
        setError('');
        setLoading(true);
        await login(values.username, values.password);
      } catch (err) {
        setError(err.message || 'Kirishda xatolik yuz berdi. Iltimos, qaytadan urinib ko\'ring.');
      }
      setLoading(false);
    },
  });

  return (
    <>
      <div className="auth-page">
        <Container>
          <Row className="justify-content-center align-items-center min-vh-100">
            <Col md={8} lg={7} xl={6}>
              <Card className="shadow-sm">
                <Card.Body className="p-4 p-sm-5">
                  <div className="text-center mb-4">
                    <h2 className="fw-bold text-primary">Tizimga kirish</h2>
                    <p className="text-muted">Hisobingiz bilan kirishingiz mumkin</p>
                  </div>
                  
                  {error && (
                    <Alert variant="danger" className="text-center">
                      {error}
                    </Alert>
                  )}

                  <Form onSubmit={formik.handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Foydalanuvchi nomi</Form.Label>
                      <Form.Control
                        type="text"
                        name="username"
                        placeholder="Foydalanuvchi nomi"
                        value={formik.values.username}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        isInvalid={formik.touched.username && !!formik.errors.username}
                        className="py-2"
                      />
                      {formik.touched.username && formik.errors.username && (
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.username}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Parol</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          type={showPassword ? 'text' : 'password'}
                          name="password"
                          placeholder="Parol"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={formik.touched.password && !!formik.errors.password}
                          className="py-2"
                        />
                        <button
                          type="button"
                          className="btn btn-link position-absolute end-0 top-50 translate-middle-y me-2 text-decoration-none"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-muted`}></i>
                        </button>
                        {formik.touched.password && formik.errors.password && (
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.password}
                          </Form.Control.Feedback>
                        )}
                      </div>
                    </Form.Group>

                    {/*<div className="d-flex justify-content-between align-items-center mb-4">*/}
                    {/*  <Link to="/forgot-password" className="text-primary text-decoration-none small">*/}
                    {/*    Parolni unutdingizmi?*/}
                    {/*  </Link>*/}
                    {/*</div>*/}

                    <Button 
                      type="submit" 
                      variant="primary" 
                      className="w-100 py-2 mb-3"
                      disabled={loading}
                    >
                      {loading ? 'KIRILMOQDA...' : 'KIRISH'}
                    </Button>

                    {/*<div className="text-center">*/}
                    {/*  <span className="text-muted">Hisobingiz yo'qmi? </span>*/}
                    {/*  <Link to="/register" className="text-primary text-decoration-none fw-medium">*/}
                    {/*    Ro'yxatdan o'tish*/}
                    {/*  </Link>*/}
                    {/*</div>*/}
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/*<div className="position-absolute bottom-0 start-50 translate-middle-x mb-4">*/}
      {/*  <Link to="/" className="text-decoration-none">*/}
      {/*    <i className="fas fa-arrow-left me-2"></i> Bosh sahifaga qaytish*/}
      {/*  </Link>*/}
      {/*</div>*/}
    </>
  );
};

export default Login;
